import type { BeePerk, SearchPerkResult } from '../../types'

/**
 * Transforms a BeePerk (from individual perk API) to SearchPerkResult format
 * (needed by PerkModal component). This enables using PerkModal with data
 * loaded from either search results or individual perk endpoints.
 */
export const transformBeePerkToSearchResult = (
  beePerk: BeePerk,
): SearchPerkResult => {
  return {
    id: beePerk.id,
    companyName: beePerk.company_name,
    logoUrl: beePerk.logo_url,
    perkShortDesc: beePerk.perk_short_desc,
    value: beePerk.value,
    valueCurrency: beePerk.value_currency,
    isGlobalNetworkPartner: beePerk.is_global_network_partner,
    createdAt: beePerk.created_at,
    categories: beePerk.categories,
    locations: beePerk.locations,
    redemptionHtml: beePerk.redemption_html,
    companyDescHtml: beePerk.company_desc_html,
    perkLongDescHtml: beePerk.perk_long_desc_html,
    requirementsHtml: beePerk.requirements_html,
    companyUrl: beePerk.company_url,
    expiresAt: beePerk.expires_at,
    etlAt: beePerk.etl_at,
    updatedAt: beePerk.updated_at,
    isTechstarsCompany: beePerk.is_techstars_company,
    priority: beePerk.priority,
    numberOfRedemptions: 0, // BeePerk doesn't have this field, set default
  }
}
